export default __webpack_public_path__ + "static/media/women-portrait.c23b296b.svg";